<template>
  <div id="kt_footer" class="d-flex flex-lg-column bg-white py-4 footer">
    <!--begin::Container-->
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <!--begin::Copyright-->
      <div class="order-2 order-md-1 text-dark">
        <span class="mr-2 font-weight-bold text-muted">{{ year }}©</span>
        <a href="#" class="text-dark-75 text-hover-primary">Innocalls</a>
      </div>
      <!--end::Copyright-->
      <!--begin::Nav-->
      <div class="order-1 order-md-2 nav nav-dark">
        <!-- <a
          href="#"
          target="_blank"
          class="pr-3 pl-0 nav-link"
          >About</a
        >
        <a
          href="#"
          target="_blank"
          class="px-3 nav-link"
          >Team</a
        >
        <a
          href="#"
          target="_blank"
          class="pr-0 pl-3 nav-link"
          >Contact</a
        > -->
        Version {{ version }}
      </div>
      <!--end::Nav-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import meta from "../../../../meta.json";

export default {
  name: "KTFooter",
  data() {
    return {
      apiVersion: "",
      meta,
    };
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
    version() {
      return meta.version.toFixed(2);
    },
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
